var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 37 37",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("circle", {
        attrs: { cx: "18.4961", cy: "18.3242", r: "18", fill: "#57B7DF" },
      }),
      _c("path", {
        attrs: {
          d: "M27.0167 11.7974L26.4884 11.269L22.799 7.57922C22.7986 7.57883 22.7986 7.57883 22.7986 7.57883L22.4993 7.27953C22.3615 7.1421 22.1786 7.06641 21.9841 7.06641H10.7179C10.2571 7.06641 9.76172 7.422 9.76172 8.20227V22.2061V28.6258V28.8055C9.76172 29.1304 10.0882 29.4468 10.4745 29.5466C10.4942 29.552 10.5133 29.5594 10.5335 29.5633C10.594 29.5753 10.6557 29.5819 10.7179 29.5819H26.2745C26.3366 29.5819 26.3983 29.5753 26.4589 29.5633C26.4791 29.5594 26.4981 29.552 26.5179 29.5466C26.9042 29.4468 27.2306 29.1304 27.2306 28.8055V28.6258V22.2061V12.4926C27.2306 12.1949 27.1945 11.9748 27.0167 11.7974ZM22.5723 8.45033L25.8467 11.7248H22.5723V8.45033ZM10.7179 28.8055C10.6903 28.8055 10.6654 28.7958 10.641 28.7865C10.5808 28.7578 10.5381 28.6972 10.5381 28.6258V22.9825H26.4542V28.6258C26.4542 28.6972 26.4115 28.7578 26.3514 28.7865C26.3269 28.7958 26.3021 28.8055 26.2745 28.8055H10.7179ZM10.5381 22.2061V8.20227C10.5381 8.11804 10.5509 7.8428 10.7179 7.8428H21.8184C21.8056 7.89172 21.7959 7.94218 21.7959 7.99459V12.5012H26.3021C26.3545 12.5012 26.4049 12.4915 26.4539 12.4787C26.4539 12.4845 26.4542 12.4868 26.4542 12.4926V22.2061H10.5381Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M16.0275 26.0489C16.1583 25.8505 16.2239 25.6102 16.2239 25.3272C16.2239 25.1397 16.1839 24.9708 16.1043 24.8202C16.0247 24.6696 15.9203 24.5415 15.791 24.4355C15.6618 24.3295 15.5158 24.2496 15.3532 24.1968C15.1901 24.1436 15.0255 24.1172 14.8598 24.1172H13.7344V28.0287H14.3714V26.6168C14.5022 26.6168 14.6059 26.6168 14.682 26.6168C14.7581 26.6168 14.8147 26.6168 14.852 26.6168C14.8893 26.6168 14.9164 26.616 14.9343 26.6141C14.9518 26.6121 14.9661 26.6114 14.9766 26.6114L15.7142 28.0283H16.3881L15.4964 26.4891C15.7196 26.394 15.8963 26.2472 16.0275 26.0489ZM15.1835 26.1102C15.1055 26.1366 15.0279 26.1502 14.9498 26.1502H14.3714V24.6005H14.8489C15.0115 24.6005 15.1424 24.6261 15.2417 24.6774C15.3407 24.7286 15.4176 24.7923 15.4727 24.8684C15.5279 24.9444 15.5636 25.024 15.5814 25.1071C15.5989 25.1902 15.6078 25.2635 15.6078 25.3272C15.6078 25.4864 15.588 25.6199 15.5496 25.7278C15.5104 25.8357 15.4595 25.9196 15.3959 25.9798C15.3322 26.0399 15.2612 26.0834 15.1835 26.1102Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M17.0312 24.5524H18.1989V28.0287H18.841V24.5524H20.0087V24.1172H17.0312V24.5524Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M20.7812 28.0287H21.4288V26.2666H23.0635V25.8315H21.4288V24.6001H23.2277V24.1172H20.7812V28.0287Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M12.478 12.5015H14.8072C15.0219 12.5015 15.1954 12.3276 15.1954 12.1133C15.1954 11.899 15.0219 11.7251 14.8072 11.7251H12.478C12.2634 11.7251 12.0898 11.899 12.0898 12.1133C12.0898 12.3276 12.2634 12.5015 12.478 12.5015Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M12.478 14.4419H15.9718C16.1865 14.4419 16.36 14.268 16.36 14.0537C16.36 13.8394 16.1865 13.6655 15.9718 13.6655H12.478C12.2634 13.6655 12.0898 13.8394 12.0898 14.0537C12.0898 14.268 12.2634 14.4419 12.478 14.4419Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M17.5249 14.4424C17.6258 14.4424 17.7268 14.3997 17.8005 14.3299C17.8704 14.2561 17.9131 14.1552 17.9131 14.0542C17.9131 13.9533 17.8704 13.8524 17.8005 13.7786C17.653 13.635 17.3968 13.635 17.2493 13.7786C17.179 13.8524 17.1367 13.9494 17.1367 14.0542C17.1367 14.1591 17.179 14.2561 17.2493 14.3299C17.3227 14.3997 17.424 14.4424 17.5249 14.4424Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M19.0796 14.4419H22.1852C22.3999 14.4419 22.5734 14.268 22.5734 14.0537C22.5734 13.8394 22.3999 13.6655 22.1852 13.6655H19.0796C18.8649 13.6655 18.6914 13.8394 18.6914 14.0537C18.6914 14.268 18.8649 14.4419 19.0796 14.4419Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M12.2024 19.6014C12.1322 19.6751 12.0898 19.7722 12.0898 19.877C12.0898 19.9818 12.1322 20.0789 12.2024 20.1526C12.2758 20.2225 12.3728 20.2652 12.478 20.2652C12.5829 20.2652 12.6799 20.2225 12.7537 20.1526C12.8235 20.0789 12.8662 19.9779 12.8662 19.877C12.8662 19.7761 12.8235 19.6751 12.7537 19.6014C12.61 19.4577 12.3461 19.4577 12.2024 19.6014Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M17.1383 19.4888H14.0327C13.8181 19.4888 13.6445 19.6627 13.6445 19.877C13.6445 20.0913 13.8181 20.2652 14.0327 20.2652H17.1383C17.353 20.2652 17.5265 20.0913 17.5265 19.877C17.5265 19.6627 17.353 19.4888 17.1383 19.4888Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M24.5162 13.6655H23.7398C23.5251 13.6655 23.3516 13.8394 23.3516 14.0537C23.3516 14.268 23.5251 14.4419 23.7398 14.4419H24.5162C24.7308 14.4419 24.9044 14.268 24.9044 14.0537C24.9044 13.8394 24.7308 13.6655 24.5162 13.6655Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M12.478 16.3828H21.0184C21.2331 16.3828 21.4066 16.2089 21.4066 15.9946C21.4066 15.7804 21.2331 15.6064 21.0184 15.6064H12.478C12.2634 15.6064 12.0898 15.7804 12.0898 15.9946C12.0898 16.2089 12.2634 16.3828 12.478 16.3828Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M24.5104 15.6064H22.1812C21.9665 15.6064 21.793 15.7804 21.793 15.9946C21.793 16.2089 21.9665 16.3828 22.1812 16.3828H24.5104C24.725 16.3828 24.8986 16.2089 24.8986 15.9946C24.8986 15.7804 24.725 15.6064 24.5104 15.6064Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M12.478 18.3242H14.0308C14.2455 18.3242 14.419 18.1503 14.419 17.936C14.419 17.7218 14.2455 17.5479 14.0308 17.5479H12.478C12.2634 17.5479 12.0898 17.7218 12.0898 17.936C12.0898 18.1503 12.2634 18.3242 12.478 18.3242Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M19.4655 17.5479H15.5835C15.3688 17.5479 15.1953 17.7218 15.1953 17.936C15.1953 18.1503 15.3688 18.3242 15.5835 18.3242H19.4655C19.6802 18.3242 19.8537 18.1503 19.8537 17.936C19.8537 17.7218 19.6802 17.5479 19.4655 17.5479Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M24.5148 17.5479H21.021C20.8063 17.5479 20.6328 17.7218 20.6328 17.936C20.6328 18.1503 20.8063 18.3242 21.021 18.3242H24.5148C24.7295 18.3242 24.903 18.1503 24.903 17.936C24.903 17.7218 24.7295 17.5479 24.5148 17.5479Z",
          fill: "white",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }